import React, { Fragment } from "react";
import { Field, useFormikContext } from "formik";
import PriceFormList from "components/FormerEditor/BlockSettings/PricingTableBlock/PriceFormList";
import { fieldProps, getFieldPath } from "utils/form";
import Textarea from "components/Form/fields/Textarea";
import get from "lodash/get";
import Padder from "components/Padder";

const ProductNew = ({ name, innerNameRef }) => {
  const {
    errors,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();

  const nameFieldPath = getFieldPath(name, "name");
  const nameError = get(errors, nameFieldPath);
  const showNameError = Boolean(get(touched, nameFieldPath) && nameError);

  const nameFieldProps = {
    className:
      "f5 border-box input-reset ba pa2 db w-100 br2 lh-copy b--black-20",
    ...fieldProps({
      name: getFieldPath(name, "name"),
      setFieldValue,
      setFieldTouched
    })
  };
  if (innerNameRef) {
    nameFieldProps.innerRef = innerNameRef;
  }

  const FIELD_GROUPS = [
    <Fragment>
      <label className="f6 mb2 dib fw6">Name</label>
      <Field {...nameFieldProps} />
      {showNameError && (
        <div className="f6 w-100 self-center pt2 tl color-error">
          {nameError}
        </div>
      )}
    </Fragment>,
    <Fragment>
      <label htmlFor="description" className="f6 mb2 dib fw6">
        Description
      </label>
      <Textarea name={getFieldPath(name, "description")} />
    </Fragment>,
    <PriceFormList
      name={getFieldPath(name, "prices")}
      priceHeaderPrefix="Price"
    />
  ];

  return (
    <div className="ph3 bg-white bh--inset h-100 w-100">
      {FIELD_GROUPS.map((fieldGroup, fieldGroupIx) => (
        <div key={fieldGroupIx} className="pt3">
          {fieldGroup}
        </div>
      ))}
      <Padder theme="visible" />
    </div>
  );
};

export default ProductNew;
